import classNames from 'classnames';
import { nanoid } from 'nanoid';

import styles from './_index.module.scss';

export interface ProgressBarProps extends React.HTMLAttributes<HTMLProgressElement> {
  hasError?: boolean;
  label?: React.ReactNode;
  max: number;
  value?: number;
}

const ProgressBar = ({
  className,
  hasError = false,
  id = nanoid(),
  label,
  max,
  value = 0,
  ...props
}: ProgressBarProps) => {
  const isComplete = max > 0 && value / max >= 1;

  return (
    <>
      {label && (
        <label className={styles['progress-bar-label']} htmlFor={id}>
          {label}
        </label>
      )}
      <progress
        className={classNames(styles['progress-bar'], className, {
          [styles['has-error']]: hasError,
          [styles['is-complete']]: isComplete,
        })}
        id={id}
        max={max}
        value={value}
        {...props}
      >
        {max > 0 ? `${Math.round((value / max) * 100)}%` : 'N/A'}
      </progress>
    </>
  );
};

export default ProgressBar;
